// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../css-loader/dist/cjs.js!./container.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../css-loader/dist/cjs.js!./row.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../css-loader/dist/cjs.js!./cols.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --grid-xs-breakpoint-start: 0px;
    --grid-xs-breakpoint-end: 359px;
    --grid-xs-gutter: 0px;
    --grid-xs-margin: 24px;

    --grid-sm-breakpoint-start: 360px;
    --grid-sm-breakpoint-end: 767px;
    --grid-sm-gutter: 0px;
    --grid-sm-margin: 24px;

    --grid-md-breakpoint-start: 768px;
    --grid-md-breakpoint-end: 1023px;
    --grid-md-gutter: 16px;
    --grid-md-margin: 40px;

    --grid-lg-breakpoint-start: 1024px;
    --grid-lg-breakpoint-end: 1440px;
    --grid-lg-gutter: 24px;
    --grid-lg-margin: 40px;

    --grid-xl-breakpoint-start: 1040px;
    --grid-xl-breakpoint-end: 999999px;
    --grid-xl-gutter: 24px;
    --grid-xl-margin: 40px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@gol-smiles/tangerina-web-core/dist/grid/index.css"],"names":[],"mappings":"AAIA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,qBAAqB;IACrB,sBAAsB;;IAEtB,iCAAiC;IACjC,+BAA+B;IAC/B,qBAAqB;IACrB,sBAAsB;;IAEtB,iCAAiC;IACjC,gCAAgC;IAChC,sBAAsB;IACtB,sBAAsB;;IAEtB,kCAAkC;IAClC,gCAAgC;IAChC,sBAAsB;IACtB,sBAAsB;;IAEtB,kCAAkC;IAClC,kCAAkC;IAClC,sBAAsB;IACtB,sBAAsB;AAC1B","sourcesContent":["@import './container.css';\n@import './row.css';\n@import './cols.css';\n\n:root{\n    --grid-xs-breakpoint-start: 0px;\n    --grid-xs-breakpoint-end: 359px;\n    --grid-xs-gutter: 0px;\n    --grid-xs-margin: 24px;\n\n    --grid-sm-breakpoint-start: 360px;\n    --grid-sm-breakpoint-end: 767px;\n    --grid-sm-gutter: 0px;\n    --grid-sm-margin: 24px;\n\n    --grid-md-breakpoint-start: 768px;\n    --grid-md-breakpoint-end: 1023px;\n    --grid-md-gutter: 16px;\n    --grid-md-margin: 40px;\n\n    --grid-lg-breakpoint-start: 1024px;\n    --grid-lg-breakpoint-end: 1440px;\n    --grid-lg-gutter: 24px;\n    --grid-lg-margin: 40px;\n\n    --grid-xl-breakpoint-start: 1040px;\n    --grid-xl-breakpoint-end: 999999px;\n    --grid-xl-gutter: 24px;\n    --grid-xl-margin: 40px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
